export const transactions: angular.IComponentOptions = {
  template: require('./transactions.html'),

}



// WEBPACK FOOTER //
// ./src/app/transactions/transactions.ts